/***
 * Tipos de filtros
 */

export enum FilterType {
  /**
   * Filtro comun 
   * 
   * Ejemplo:
   * 
   * anio
   * o
   * mes
   * o
   * Que no requieran consolidado
   */
  COMMON = 'common',
  /**
   * Estructura jerárquica.
   *
   * Ejemplo:
   * Año
   *    Enero
   *    Febrero
   */
  TREE = 'tree',

  /**
   * Filtros comunes pero con el de consolidado
   */
  CONSOLIDADO = 'consolidado',
}